/* eslint-disable */

import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CourseFiles from '../course-files/index';
import CoursesDetails from '../course-details/index';
import Quiz from '../quiz/index';
import Vue from 'vue';
import { VueEditor } from "vue2-editor";
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
Vue.use(CKEditor);
export default {
  name: 'uniqueFeature',
  components: {
    'course-details': CoursesDetails,
    'course-files': CourseFiles,
    'quiz': Quiz,
    VueEditor
  },
  props: [],
  data() {
    return {
      QuizList: null,
      coursesSection: null,
      CourseMaterialList: null,
      courses_tab: 'coursesDetails',
      inputs: [],
      courseDetails: null,
      category: '',
      course: '',
      categoryList: {},
      submitted: false,
      categoryFilterName: '',
      description: '',
      name: '',
      is_active: Boolean,
      activeStatus: Boolean,
      Id: '',
      categoryId: '',
      updateCategoryId: '',
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Course Name HTML',
        toolbar: ['heading', '|']
      },
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      expertise_level_state: '',
      expertise_level: 'Add Expertise Level',
      subtitle: '',
      code: '',
      isRoleIn: '',
      producer: '',
      course_producer: '',
      author_details: '',
      courseRouteId: '',
      type_course_lavel: '',
      type_course_lavel_state: ''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getcourseCategoryState',
    ]),
    getCourseDetails() {
      this.courseDetails = this.$store.getters.getsectionbycourseIDState.data
      return;
    },
    SetIntialStatus() {
      if (this.courseDetails) {
        let producer_details = this.courseDetails.authors
        this.course_producer = producer_details.filter(producer => producer.is_producer == true);
        let authors_details = this.courseDetails.authors
        this.author_details = authors_details.filter(authors => authors.is_producer == false);
        this.activeStatus = this.courseDetails.is_active
        if (this.courseDetails.expertise_level == 'I') {
          this.expertise_level = 'Intermediate (I)'
        }
        if (this.courseDetails.expertise_level == 'E') {
          this.expertise_level = 'Entry Level (E)'
        }
        if (this.courseDetails.expertise_level == 'A') {
          this.expertise_level = 'Advance (A)'
        }
      }
    },
    getCategory() {
      this.categoryList = this.$store.getters.getcourseCategoryState.data;
      return this.categoryList
    },
    getUserDetails() {
      this.$store.dispatch('getUserRoleDetails').then((res) => {
        this.isRoleIn = res.data.data.profile.role
      }).catch((err) => { })
    }
  },
  mounted() {
    this.courseRouteId = this.$route.params.id
    this.getUserDetails
    if (this.$route.name == 'QuizList') {
      this.courses_tab = 'Quiz'
    }
    if (this.$route.name == 'CourseMaterialList') {
      this.courses_tab = 'coursesFiles'
    }
    this.getCourseDetails
    this.SetIntialStatus
    this.getCategory
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        this.courseDetails = res.data
      }).catch((err) => { })
    },
    courseActStatusFun() {
      this.submitted = true;
      if (this.activeStatus === true) {
        this.is_active = false
        console.log("false")
      }
      if (this.activeStatus === false) {
        this.is_active = true
        console.log("True")
      }
      let data = {
        is_active: this.is_active,
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Status Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    courseNameFun() {
      $('#EditCourseNamePopup').modal()
      this.name = this.courseDetails.name
      if (this.courseDetails.name_html != null) {
        if (this.courseDetails.name_html.indexOf('<p>') < 0) {
          this.editorData = '<p>' + this.courseDetails.name_html + '</p>'
        } else {
          this.editorData = this.courseDetails.name_html
        }
      }
    },
    updateCourseNameConfirmation() {
      this.submitted = true;
      let data = {
        name: this.name,
        name_html: this.editorData
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Name Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    courseDescriptionFun() {
      $('#EditCourseDescriptionPopup').modal()
      this.description = this.courseDetails.description
    },
    updateCourseDescriptionConfirmation() {
      this.submitted = true;
      let data = {
        description: this.description
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Description Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    showCourseTab(value) {
      this.courses_tab = value;
    },
    courseCategoriesFun(id) {
      $('#EditCourseCategoryPopup').modal()
      this.categoryId = id
      this.submitted = true;
      let data = {
        id: this.categoryId
      }
      this.$store.dispatch('getCategoryDetailsById', data).then((res) => {
        this.categoryFilterName = res.data.data.name
      })
      return
    },
    getCoursebyCategory(id, name) {
      this.categoryFilterName = name,
        this.updateCategoryId = id
      console.log(this.updateCategoryId, 'update category')
    },
    updateCourseCategoryConfirmation() {
      this.submitted = true;
      let data = {
        category: this.updateCategoryId,
        course: this.$route.params.id
      }
      this.$store.dispatch('updateCategoryByCourse', data).then((res) => {
        this.getCourseDetailsAgain()
        console.log(res.data)
        toast.success(res.data.msg || "Course Category Changed Successfully");
      })
      return
    },
    getexpertisefilterLevel(name) {
      if (name === "remove") {
        this.expertise_level_state = ''
      } else {
        this.expertise_level_state = name
      }
      if (name == 'E') {
        this.expertise_level = 'Entry Level (E)'
      }
      if (name == 'I') {
        this.expertise_level = 'Intermediate (I)'
      }
      if (name == 'A') {
        this.expertise_level = 'Advance (A)'
      }
      if (name == 'remove') {
        this.expertise_level = 'Add Expertise Level'
      }
    },
    typeCourseModalFun() {
      $('#updateTypePopup').modal()
      this.type_course_lavel = this.courseDetails.type
    },
    updateTypeCourseLevelFun(type) {
      this.type_course_lavel_state = type
      if (type == '1') {
        this.type_course_lavel = '1'
      }
      if (type == '2') {
        this.type_course_lavel = '2'
      }
    },
    updatedTypeCourseConfirmation() {
      this.submitted = true;
      let data = {
        type: this.type_course_lavel_state
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Type Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    addExpertiseLevelFun() {
      $('#EditExpertiseLevelPopup').modal()
    },
    updateExpertiseLevelConfirmation() {
      this.submitted = true;
      let data = {
        expertise_level: this.expertise_level_state
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Expertise Level Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    addSubTitleFun() {
      $('#EditCourseSubTitlePopup').modal()
      this.subtitle = this.courseDetails.subtitle
    },
    EditCourseSubTitlePopupConfirmation() {
      this.submitted = true;
      let data = {
        subtitle: this.subtitle
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Sub Title Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    addCourseProducerFun() {
      $('#EditCourseProducerPopup').modal()
      this.producer = this.courseDetails.producer
    },
    EditaddCourseProducerFunPopupConfirmation() {
      this.submitted = true;
      let data = {
        producer: this.producer
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Producer Updated Successfully");
        }
      }).catch((err) => { })
      return
    },
    addCourseCodeFun() {
      $('#EditCourseCodePopup').modal()
      this.code = this.courseDetails.code
    },
    EditCourseCodePopupConfirmation() {
      this.submitted = true;
      let data = {
        code: this.code
      }
      this.$store.dispatch('edit_course', {
        data: {
          data: data,
          id: this.$route.params.id
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getCourseDetailsAgain();
          toast.success("Course Code Updated Successfully");
        }
      }).catch((err) => { })
      return
    }
  },
  beforeMount() {
    this.getCourseDetails;
  },
  watch: {
    getCourseDetails() {
      return this.$store.getters.getsectionbycourseIDState.data
    },
    getCategory() {
      return this.$store.getters.getcourseCategoryState.data
    },
    SetIntialStatus() {
      if (this.courseDetails) {
        let producer_details = this.courseDetails.authors
        this.course_producer = producer_details.filter(producer => producer.is_producer == true);
        let authors_details = this.courseDetails.authors
        this.author_details = authors_details.filter(authors => authors.is_producer == false);
        this.activeStatus = this.courseDetails.is_active
        if (this.courseDetails.expertise_level == 'I') {
          this.expertise_level = 'Intermediate (I)'
        }
        if (this.courseDetails.expertise_level == 'E') {
          this.expertise_level = 'Entry Level (E)'
        }
        if (this.courseDetails.expertise_level == 'A') {
          this.expertise_level = 'Advance (A)'
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
  },
}